import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../entities/response-machine';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class SmileApi extends QuestionSimpleApi {
    public change(question: QuestionContext, evt: ResponseEventParams): void {
        const { value, questionId, answerId } = evt;
        const { answersActors, responseActor } = question;

        responseActor.send({ type: 'CHANGE', value, questionId });

        answersActors.map((answerActor) => {
            const answer = answerActor.getSnapshot().context;
            if (answer.id !== answerId) {
                answer.response.send({ type: 'SET', value: false });
            } else {
                answer.response.send({ type: 'SET', value: true });
            }
        });
    }

    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id, responseActor } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        const isCantRate = value === CANTRATE_ID;
        const data = isCantRate
            ? [{ cantRate: true, bool: true, comment }]
            : answersActors
                  .filter((actor) => actor.getSnapshot().context.response.getSnapshot().context.value)
                  .map((actor) => {
                      const { id, value } = actor.getSnapshot().context;
                      return {
                          answer: id,
                          text: value[0],
                          bool: true,
                      };
                  });

        return {
            question: id,
            data,
            comment,
        };
    }

    public validate({ answersActors, responseActor, params: { required } }: QuestionContext): boolean {
        const { value } = responseActor.getSnapshot().context;
        const isCantRate = value === CANTRATE_ID;
        if (isCantRate) return true;
        if (required) {
            return answersActors.some(
                (answerActor) => !!answerActor.getSnapshot().context.response.getSnapshot().context.value,
            );
        }

        return true;
    }
}
